import { identify, makeRequest, Service } from '../../../utils/http';

export async function getAllProjectsApi() {
  return makeRequest(Service.getProjects(await identify()));
}
